<template>
    <div class="mx-0 my-1 solid" >
        <p v-if="mobile"  color="orange" class="ma-0 pa-0 " @click="setSeeDescription()" >
            <span class="text-body-2 orange--text  ">Description </span>
            <v-btn v-if="!toggleDown" x-small class="mx-1 mt-1 mb-3" fab dark color="orange">
                <v-icon dark>mdi-plus</v-icon>
            </v-btn>
            <v-btn v-else x-small class="mx-0 mt-1 mb-3" fab dark color="orange">
                <v-icon dark>mdi-minus</v-icon>
            </v-btn>
        </p>
        <p v-else class="px-0  text-justify my-0 py-0" >
            <span v-html="description" class="body-2"></span>
        </p>
        <p v-if="toggleDown" class="px-0 pr-1 text-justify my-0 py-0" >
            <span v-html="description" class="body-2"></span>
        </p>
        <p v-if="grant.institution" class="text-body-2 font-weight-bold ma-0 pt-2"> Participating institutions</p>
        <p v-if="grant.institution" v-html="institution" class="ma-0 pa-0">
        </p>
        <p v-if="grant && grant.grant_info.url_file" class="mt-2 py-1">
            <a class=" indigo--text text--darken-2 font-weight-bold" :href="grant.grant_info.url_file" target="_blanc">
                <span v-if="grant.grant_info.title_file" v-html="grant.grant_info.title_file"></span>
                <img  v-if="!mobile" src="../../assets/research/acrobat_icon.png" class="pl-0 pt-1">
                <span v-else class="text-body-2 purple--text text--purple-4 px-0"> Download PDF</span>
            </a>
        </p>
  </div>
</template>
<script>

function sanitizeParagraph(text) {
    return text.replace(/<p>/g,"<p class=\"ma-0\">",);
}

import {mapGetters} from 'vuex';

export default {
  props:['grant'],
  data(){
    return{
      toggleDown:false,
    }
  },
  computed:{
    ...mapGetters('grants',{
      typeGrantChanged:'typeGrantChanged',
      typeGrant:'typeGrant',
    }),
    ...mapGetters('header',{
      mobile:'mobile',
    }),
    institution(){
        if(this.grant && this.grant.institution){
            return sanitizeParagraph(this.grant.institution);
        }
        else
            return null;
    },
    description(){
        if (this.grant && this.grant.grant_info.description) {
            return sanitizeParagraph(this.grant.grant_info.description);
        }
        else
            return null;

    }
  },
  methods:{
    setSeeDescription() {
      this.toggleDown = !this.toggleDown;
    }
  }
}
</script>
<style scoped>
.solid {
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: grey;
}
</style>
